import { render, staticRenderFns } from "./DoctorAudit.vue?vue&type=template&id=512adef8&scoped=true&"
import script from "./DoctorAudit.vue?vue&type=script&lang=js&"
export * from "./DoctorAudit.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAudit.vue?vue&type=style&index=0&id=512adef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512adef8",
  null
  
)

export default component.exports